import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import TreeSpeciesSelector from '../../../../helpers/TreeSpeciesSelector';
import { HtmlElement } from '../../../../../helpers/HtmlElements/HtmlElements';
import { debug } from './../../../../../../utils'
import MapWidget from './../../../../../helpers/MapWidget/MapWidget';
import MediaAcquisitionToolbar from 'components/helpers/MediaAcquisitionToolbar/MediaAcquisitionToolbar';
import CustomAlert from 'components/helpers/CustomAlert/CustomAlert';
import LayerSelector from 'components/projects/helpers/LayerSelector';
const TreeFormFeatures = ({ item, onChange }) => {
  const { t } = useTranslation();
  const project = useSelector(state => state.project);
  const [treeIdentityAddtionalItems, setTreeIdentityAddtionalItems] = useState([]);
  const [parent, setParent] = useState({ itType: 'layer' });
  useEffect(() => {
    let addtionalItems = [];
    if (item?.projMeta != undefined) {
      const cat = item.projMeta.find(c => c.slug === 'treeIdentity')
      if (cat) {
        addtionalItems = cat.items.filter(i => i.active === true)
      }
    }
    setTreeIdentityAddtionalItems(addtionalItems);
    const parent = project.items.find(it => it.itId == item.itParentId);
    if (parent) {
      setParent(parent);
    }

  }, [item]);
  useEffect(() => {
    if (item?.projMeta && item.itId == '') {
      const defaultMeta = {};
      item.projMeta.forEach(cat => {
        cat.items.forEach(it => {
          if (it.active && it.hasOwnProperty('default')) {
            const key = `${cat.slug}/${it.id}`;
            defaultMeta[key] = it.default;
          }
        });
      });
      onChange({ meta: defaultMeta });
    }
  }, [item?.projMeta]);
  const executeActions = (actions, setItemMeta) => {
    const updatedMeta = { ...item.meta };
    actions.forEach(action => {
      switch (action.action) {
        case 'calculate':
          const result = parseFloat(eval(action.expression.replace('item.meta', 'updatedMeta')));
          updatedMeta[action.target] = result;
          break;
      }
    });
    onChange({ meta: updatedMeta });
  };
  const breakpointColumnsObj = {
    default: 3,
    992: 3,
    768: 2,
    500: 1
  };
  return (
    <div id="TreeFormFeatures">
      <div className="mb-3 ">
        <div className="card card-identity">
          <h6 className='card-title mb-3'>Identité</h6>
          <div className="card-body">
            <div className='card-text'>
              {parent.itType !== 'layer' &&
                <div className="form-group small text-green-1 mb-3">
                  Sujet rattaché à un {t(parent.itType)} ({parent && <em>{parent.itName}</em>})
                </div>}
              <div className='row'>
                <div className='col-md-4'>
                  <div className='row'>
                    <div className='col-4'>
                      <HtmlElement.formGroup value={item.itRef} name='itRef' label='Numéro :' onChange={onChange} required={true} />
                    </div>
                    <div className='col-8'>
                      <HtmlElement.formGroup value={item.itName} name='itName' label='Nom :' onChange={onChange} />
                    </div>
                  </div>
                  <HtmlElement.formGroup type="date" value={item.meta.diagnosisDate} name='meta.diagnosisDate' label='Date du diagnostic:' onChange={onChange} required={true} />
                  {parent.itType == 'layer' &&
                    <LayerSelector
                      selectedId={item.itParentId}
                      name='itParentId'
                      onChange={onChange}
                      required={true}
                      allowCreate={true}
                    />
                  }
                  <div className="form-group">
                    <TreeSpeciesSelector
                      onUpdate={obj => onChange({ meta: { ...item.meta, ...obj } })}
                      essence_fr={item.meta.essence_fr}
                      essence_lt={item.meta.essence_lt}
                      cultivar={item.meta.cultivar}
                    />
                  </div>
                  {/* <HtmlElement.formGroup value={item.meta.origin} name='meta.origin' label='Origine : ' onChange={onChange} /> */}
                </div>
                <div className='col-md-4'>
                  {treeIdentityAddtionalItems.map((it, idxi) => {
                    const Element = HtmlElement[it.type] || HtmlElement.input;
                    return Element && (
                      <div key={idxi} className='mb-2'>
                        <label className='form-group-label mb-1'>{it.text} : </label>
                        <Element
                          name={`meta.treeIdentity/${it.id}`}
                          value={item.meta[`treeIdentity/${it.id}`]}
                          onChange={onChange}
                          {...(it.options && { options: it.options })}
                          {...(it.onBlur && { onBlur: () => executeActions(it.onBlur) })}
                        />
                      </div>
                    );
                  })}
                </div>
                <div className='col-md-4'>
                  {(item?.itGeometry && item?.itGeometry?.length == 2) &&
                    <div className='position-relative mb-3' style={{ paddingTop: '100%' }}>
                      <div className='position-absolute h-100 w-100' style={{ top: 0, left: 0 }}>
                        <MapWidget position={item.itGeometry} zoom={20} icon="tree" onMarkerChange={onChange} unlocked={true} />
                      </div>
                    </div>
                  }
                  <div className='mb-3 text-center'>
                    {false && (!item.itId || item.itId == '') &&
                      <CustomAlert input="Veuillez sauvegader le formulaire pour accéder aux outils multimédia" variant="warning" />
                    }
                    <MediaAcquisitionToolbar onMediaCreated={media => onChange({ medias: [...item.medias, media] })} medParentId={item.itId} disabled={!item.itId && false} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {item.projMeta?.map((cat, idxc) => (
          (cat.active && cat.slug !== 'treeIdentity' && cat.slug != 'dendrometry' && cat.slug != 'physiology' && cat.slug != 'recommendation') && (
            <div className="accordion" id={`accordion${idxc}`} key={idxc}>
              <div className="accordion-item">
                <h6 className="accordion-header" id={`heading${idxc}`}>
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${idxc}`} aria-expanded="true" aria-controls={`collapse${idxc}`}>
                    {cat.text} :
                  </button>
                </h6>
                <div id={`collapse${idxc}`} className="accordion-collapse collapse" aria-labelledby={`heading${idxc}`} data-bs-parent={`#accordionExample${idxc}`}>
                  <div className="accordion-body">
                    <div className='card'>
                      <div className="card-body">
                        <div className='card-text'>
                          {cat.items.map((it, idxi) => {
                            const Element = HtmlElement[it.type] || HtmlElement.input;
                            return it.active && Element && (
                              <div key={idxi} className='mb-2'>
                                <label className='form-group-label mb-1'>{it.text} : </label>
                                <div className="input-group w-100">
                                  {it.igBefore && <span className='input-group-text'>{it.igBefore}</span>}
                                  <Element
                                    {...it}
                                    value={item.meta[`${cat.slug}/${it.id}`]}
                                    onChange={onChange}
                                    name={`meta.${cat.slug}/${it.id}`}
                                    {...(it.options && { options: it.options })}
                                    {...(it.onBlur && { onBlur: () => executeActions(it.onBlur) })}
                                  />
                                  {it.igAfter && <span className='input-group-text'>{it.igAfter}</span>}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ))}
      </Masonry>
      {debug(item.meta)}
    </div>
  );
};
export default TreeFormFeatures;
